import { UserMatchingDto } from "@api-types/user/UserMatchingDto";
import {
	CompleteTakeoverWithLimitDto,
	CreateUserDto,
} from "@data-types/membership/registration";
import CaptchaService from "@services/captcha/CaptchaService";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformRegistrationApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/gp/register`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async registerTerminalUser(
		body: CreateUserDto,
		terminalShopId: string
	): Promise<Response> {
		const token = await CaptchaService.executeCaptcha(
			"terminalRegistration"
		);

		if (token) {
			body.challengeResponse = token;
		}

		return httpClient.post(
			`${this.baseUrl}/retail-on-web`,
			JSON.stringify(body),
			{
				...this.getRequestHeaders(),
				"Shop-Id": terminalShopId,
			},
			{ responseType: "raw" }
		);
	}

	static async registerUser(body: CreateUserDto) {
		const token = await CaptchaService.executeCaptcha("registration");

		if (token) {
			body.challengeResponse = token;
		}

		return await httpClient.post(
			`${this.baseUrl}`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}

	static async registerSeUser(body: CreateUserDto) {
		const token = await CaptchaService.executeCaptcha("registration");

		if (token) {
			body.challengeResponse = token;
		}

		return await httpClient.post(
			`${this.baseUrl}/SE`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}

	static async confirmUserMatchingAndCompleteRegistration(
		userMatchingDto: UserMatchingDto
	) {
		return await httpClient.post(
			`${this.baseUrl}/confirm-match-and-complete-registration`,
			JSON.stringify(userMatchingDto),
			this.getRequestHeaders()
		);
	}

	static async completeTakeoverWithLimit(
		completeTakeoverWithLimitDto: CompleteTakeoverWithLimitDto
	) {
		return await httpClient.post(
			`${this.baseUrl}/complete-takeover-with-limit`,
			JSON.stringify(completeTakeoverWithLimitDto),
			this.getRequestHeaders()
		);
	}

	static registrationActivate(username: string, mailkey: string) {
		return httpClient.put(
			`${this.baseUrl}/activate/${username}/${mailkey}`,
			null,
			this.getRequestHeaders(),
			{ responseType: "raw" }
		);
	}
}

export default PlatformRegistrationApiService;
